import { ICustomTableHeadProps } from './interfaces';

const CustomTableHead = ({ columnsMetadata }: ICustomTableHeadProps) => {
  return (
    <thead>
      <tr>
        {columnsMetadata.map((column) => (
          <th key={column.key}>{column.displayName}</th>
        ))}
      </tr>
    </thead>
  );
};

export default CustomTableHead;
